import { render, staticRenderFns } from "./SubFolderLoadDocuments.vue?vue&type=template&id=6209ccc1&scoped=true&"
import script from "./SubFolderLoadDocuments.vue?vue&type=script&lang=js&"
export * from "./SubFolderLoadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderLoadDocuments.vue?vue&type=style&index=0&id=6209ccc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209ccc1",
  null
  
)

export default component.exports